export class AvailableClass {
    id: number;
    name: string;
    room: string;
    teacher: string;
    startDate: string;
    endDate: string;
    duration: number;
    lessons: string[];
    feePerSession: number;
    isFree: boolean;
    maxStudents: number;
    bookingCount: number;
    reservationCount: number;
    type: any;
}


// WEBPACK FOOTER //
// ./src/holiday/models/AvailableClass.ts